// Demo mode utilities

/**
 * Check if the application is running in demo mode
 * Demo mode is triggered by ?demo or ?demo=true URL parameter
 */
export function isDemoMode(): boolean {
  const params = new URLSearchParams(window.location.search)
  return params.has('demo')
}

/**
 * Redirect to demo mode
 * Removes garden parameter and adds demo=true
 */
export function redirectToDemo(): void {
  const url = new URL(window.location.href)
  url.searchParams.set('demo', 'true')
  url.searchParams.delete('garden') // Use demo garden instead
  window.location.href = url.toString()
}

/**
 * Get the demo garden ID (constant)
 * Used when loading demo mode
 */
export function getDemoGardenId(): string {
  return 'demo'
}
